import { render, staticRenderFns } from "./tellist.vue?vue&type=template&id=5911dc77&scoped=true&"
import script from "./tellist.vue?vue&type=script&lang=js&"
export * from "./tellist.vue?vue&type=script&lang=js&"
import style0 from "./tellist.vue?vue&type=style&index=0&id=5911dc77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5911dc77",
  null
  
)

export default component.exports